module.exports = __webpack_public_path__ + "img/img_total_propterty.4c86d37a.png";